import axios from 'axios';
import React, { useState } from 'react';
import { setDataOnLocal, getDataOnLocal,getSubdomain } from '../../../utils/AppHelper';
import { getAccessTokenData, logoutUser } from '../../../utils/AxoisHelper';
import { axiosConfig } from "../../../utils/Constants.config";


let headers = {
  Authorization: "",
  token_type: "",
  account_id: "",
};

const getRequest = () => ({ method: 'GET' })
const getRequestWithParams = (data) => ({ method: 'GET', params: data })
const postRequest = (data) => ({ method: 'POST', data })
const postRequestWithParams = (data) => ({ method: 'POST', params: data })

const checkTokenIsValid = async (res) => {
  const dataMsg = res?.data?.errorMessage?.toLowerCase() || res?.errorMessage?.toLowerCase();
  const dataStatus = res?.data?.code || '';
  const errorMsgArr = ['invalid token', 'token is missing', 'token is expired', 'token is expired.', 'token not found in db.','Token Expired, Please login again!','invalid token.','Access denied. No token provided.']
  const isErrorMsgPresent = errorMsgArr?.some(msg => msg?.toLowerCase() === dataMsg?.toLowerCase());
  if (dataStatus === 401 &&dataStatus !== 200 && isErrorMsgPresent) {
    await logoutUser(); 
  }
}
const callApi = async (url, options, hearderParams, additionalParams = null) => {
  let res = null

  if (additionalParams?.isInterceptors) {
    // Add a request interceptor
    const axoisRequestInterceptors = axios.interceptors.request.use(function (config) {
      return config;
    }, function (error) {
      return Promise.reject(error);
    });

    // Add a response interceptor
    const axoisResponseInterceptors = axios.interceptors.response.use(function (response) {
      checkTokenIsValid(response);
      return response;
    }, function (error) {
      return Promise.reject(error);
    });
    //axios.interceptors.request.eject(axoisRequestInterceptors);
  }

  try {
    const { account_id, authorization, password } = hearderParams
    headers = {
      'Content-Type': 'application/json',
      'account_id': '',
      'token_type': '',
      'Authorization': '',
    };
    if (authorization) {
      headers['authtoken'] = authorization
    }
    if (password && additionalParams?.isPassword) {
      headers['password'] = password
    }
    if (account_id) {
      headers['account_id'] = account_id
    }

    res = await axios({ url, ...options, headers })
    res = await res.data
    return res
  } catch (error) {
    res = { isError: true, msg: error.message }
    return res
  }
}

const getAxiosConfig = (dataParam) => {
  let {withCredentials}=axiosConfig
  let dataParams =dataParam || {}
  const accessTokenData = getAccessTokenData();
  if (dataParams['Cache-Control'] !== undefined && dataParams['Cache-Control'] !== null) {
    headers['Pragma'] = dataParams['Cache-Control'];
  } else {
    delete headers['Cache-Control']
  }
  if (dataParams['Accept'] !== undefined) {
    headers['Content-Type'] = dataParams['Content-Type']
  }else if (dataParams.type === 'upload') {
    headers['Content-Type'] = 'multipart/form-data'; // Set for file upload
  } 
  else {
    headers['Content-Type'] = 'application/json'
  }
  
  // headers.account_id = accessTokenData?.account_id || '';
  headers['authtoken'] = accessTokenData || '';
  headers['client-code'] = getSubdomain() || 'tatamotors';
  const { type } = dataParams;
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  let config = { baseURL: '', cancelToken: source.authtoken, headers, withCredentials };
  if (type === 'upload') {
    config.onUploadProgress = (event) => {
      const progress = Math.round((event.loaded * 100) / event.total);
  };
  } else if (type === 'download') {
    config.onDownloadProgress= (event) => {
      const progress = Math.round((event.loaded * 100) / event.total);

      };
  }

   const axiosInstance = axios.create(config);

  // Response interceptor
  axiosInstance.interceptors.response.use(
    (response) => {
      // Successful response, return it
      return response;
    },
    (error) => {
      const res = error.response;
      if (res && res.data) {
        checkTokenIsValid(res); // Check for token errors
      }

      // Return the formatted error
      return Promise.reject(getFomatedError(res?.data));
    }
  );

  return { axiosInstance, source, config }
};

const getFomatedError = (err) => {
  const { code, errorMessage,message, name } = err;
  let error = {isError: true, errorCode: code, errorMessage: errorMessage || message, errorName: name||'' };
  return error;
}
const setFormatedResponse = (res) => {
  const { code,errorMessage, message,success ,data} = res.data;
  let resData = {isError:false, code: code, message: errorMessage || message, success: success,data:data };
  return resData;
}

export {
  headers,
  getRequest,
  getRequestWithParams,
  postRequest,
  postRequestWithParams,
  callApi,
  getAxiosConfig,
  getFomatedError,
  setFormatedResponse
};